<template>
  <div class="login-app-wrapper" />
</template>
<script>
export default {
    name: "LoginApp"
};
</script>
<style lang="less">
    .login-app-wrapper, .login-app-wrapper > [id^=__qiankun_microapp_wrapper] {
        height: 100%;
    }
</style>